var _defs, _path, _rect, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path2, _path3, _rect3, _text, _rect4, _rect5, _rect6, _text2, _rect7, _rect8, _rect9, _text3, _rect0, _rect1, _rect10, _text4, _rect11, _rect12, _rect13, _text5, _rect14, _rect15, _rect16, _text6, _rect17, _text7, _rect18, _text8, _rect19, _text9, _rect20, _text0, _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclosureTimelineMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "145px",
    height: "865px",
    viewBox: "-0.5 -0.5 145 865",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-11-15T18:43:29.100Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/95.0.4638.69 Safari/537.36\" etag=\"SSMjV01CTtsk6_e2ITdO\" version=\"15.7.3\" type=\"device\"><diagram id=\"uSI-kXjQStKMSb3QKwHk\" name=\"Page-1\">7Zptc6I6FMc/jS91CCE8vLSW3nVHW0ed9nVWorCLxIlxtffT3yDhIYZu2blWHRVnWnLIA5zf+ZOcaAv2lrt/GF6FQxqQuGUawa4FH1umCSzgiH+p5V1aPAAzy4JFgbSVhkn0L5FGQ1o3UUDWSkVOacyjlWqc0SQhM67YMGN0q1ab01gddYUXRDNMZjjWrW9RwMPM6iKjtH8j0SLMRwaGvLLEeWVpWIc4oNuKCfot2GOU8uxsueuROPVe7pes3dMHV4sbYyThTRqw0djdto1vb3T0ffg0iVwS87bs5TeON/KB5c3y99wDcZSIs4c1Z/RX4QMkLEHEhMcjmojylqzFTTyEfBmLEhCn8yiOezSmTJQTuu9iThMuCYsoyMp5lZYJjf0h7DiOFmmnM/FkhBVjV6rCh/QjrjDKsbyFtpe2lc9DGCe7Dx0FCveLwCV0STh7F1VkgzbwJDIZtGZOe1uJAEvawip9acMy6BZF3yUXcSLR/AUm83NMjG6SgATS+9sw4mSywrP06lZoU4WjOlTiUQkfMhRen6P08znI7KgDuWA4iEThsRI6BO9DJ0UWCd11ZRtO03suRAOOw9a0vI5XPRyFdBs4SEMNDNhBUKdtfRVt+Dlt0Yt4A5LPSeP1KnstzqNdGh1N0KMa9AYOLHIkBgAdOl3XF6yRF/wqh1s35nDzzP5Gt+Vv98zutm/L3RDo7/CT+tu5PH+j2Q8Xzb7G35Z35vh2b8vfds1y9KT+Bk0WKIFIo2SRMh7SBU1w7JfWh3LBmq7byzoDmq789jB+Es7f5UITbzhVUWVjpgP92bEiY8RsQfif1tewngAjsUgvfqsD1PlTNh3RSAxdkIMG6Di2g2zgIQiR6SkckYk6yCgPU+1+TTdsRmSPB8SKW/wfEPVZYez3/P6r/6jBFLF7kN3VqqIm5dMygMNl/jIKgvgjXaohcgwpOQKItuTX5WSfVE4N5ot7dtcILzI6hlHJ7mwVtXkByR3QZ6ux/9r334St9zIcDfzp1SvQPcBybgF6dwEeUYBAoXsJGyp5gFUAT/znqbBMX8SfQTcV31N/PLxi3dmoY6ozn+N2LKDBcWrAQNjJX1vHZ9NgC/ouvuazX+WACm4IzILiWcVoasAfx92nVI03uQCFwKnjctIZ0GyQ0d1F2FCECl3LtTqXMAPqW9yj7jSbA7uj0X76G1y18GzrcP6zXK8GTb5eOY3uGuyE33XXfOVZSf3UHMO2LkGE+pbLoN/znye+ML6Mpv2X5ysW4D7x+zA3r9vUPO0UqO/CiAcyhkIB4RVTsdTpql2zl39aDPr2SFp8I+TX+poxHHyFBc9MQd8RgbkYbghD8YOec3GA+saFeYMcrK/jIIrlT/Cy71bKXzJC/z8=</diagram></mxfile>",
    style: {
      backgroundColor: "rgb(255, 255, 255)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M -403 430 L 437 430",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    transform: "rotate(90,17,430)",
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 0,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 0,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 20,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 170,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 270,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 505,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 680,
    rx: 15,
    ry: 15,
    fill: "#5cb85c",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17,
    cy: 840,
    rx: 15,
    ry: 15,
    fill: "#5cb85c",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 88.77 700.5 L 88.83 680.5 L 88.83 693.13",
    fill: "none",
    stroke: "rgba(0, 0, 0, 1)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 88.83 698.38 L 85.33 691.38 L 88.83 693.13 L 92.33 691.38 Z",
    fill: "rgba(0, 0, 0, 1)",
    stroke: "rgba(0, 0, 0, 1)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 58.77,
    y: 5,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 20,
      marginLeft: 60
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "RECEIVED")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 24,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "RECEIVED")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37.01,
    y: 150,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 37.01,
    y: 150,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58.78,
    y: 155,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 170,
      marginLeft: 60
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "REVIEW COMPLETED")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 174,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "REVIEW COM...")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 37.01,
    y: 250,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 37.01,
    y: 250,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 52.27,
    y: 253.41,
    width: 73,
    height: 33.18,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 71,
      height: 1,
      paddingTop: 270,
      marginLeft: 53
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SENT TO LAW FIRM")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 274,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "SENT TO LAW...")))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 487.18,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 487.18,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 58.77,
    y: 492.18,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 507,
      marginLeft: 60
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "DRAFT RECEIVED")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 511,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DRAFT RECE...")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 659.5,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 659.5,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 51.27,
    y: 664.5,
    width: 75,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 73,
      height: 1,
      paddingTop: 680,
      marginLeft: 52
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "PATENT APP FILED")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 683,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "PATENT APP F...")))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 37.02,
    y: 820,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 37.02,
    y: 820,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 58.79,
    y: 825,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 840,
      marginLeft: 60
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "LICENSE OPTION")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 844,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "LICENSE OP...")))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 85,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 100,
      marginLeft: 28
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1 Month")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 57,
    y: 104,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1 Month")))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 208,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 223,
      marginLeft: 33
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2 Weeks")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 227,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2 Weeks")))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 385,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 400,
      marginLeft: 33
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "3 Months")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 404,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "3 Months")))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 585,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 600,
      marginLeft: 33
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2 Months")))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 62,
    y: 604,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2 Months"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclosureTimelineMobile);
export default __webpack_public_path__ + "static/media/disclosure_timeline_mobile.11e16186061fa2f0dff65dedbace609a.svg";
export { ForwardRef as ReactComponent };